import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'
import main_page from '../views/main_page.vue'
import car_info from '../views/car_info.vue'
import event_list from '../views/event_list.vue'
import event_info from '../views/event_info.vue'
import categories_list from '../views/categories_list.vue'
import categories_info from '../views/categories_info.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/login',
        component: login,
        meta: {
            auth: false
        }
    },
    {
        path: '/flota',
        component: main_page,
        meta: {
            auth: true
        }
    },
    {
        path: '/vozilo',
        component: car_info,
        meta: {
            auth: true
        }
    },
    {
        path: '/rezervacije',
        component: event_list,
        meta: {
            auth: true
        }
    },
    {
        path: '/rezervacija',
        component: event_info,
        meta: {
            auth: true
        }
    },
    {
        path: '/kategorije',
        component: categories_list,
        meta: {
            auth: true
        }
    },
    {
        path: '/kategorija',
        component: categories_info,
        meta: {
            auth: true
        }
    }
]

const router = new VueRouter({
    routes
})

export default router